/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetNewbuildingsForSerpRequest,
  TGetNewbuildingsForSerpModel,
  IMappers,
  TGetNewbuildingsForSerpResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingsForSerpResponse } from '../../entities/get_newbuildings_by_params/GetNewbuildingsForSerpResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingsForSerpModel(
  parameters: TGetNewbuildingsForSerpRequest,
): TGetNewbuildingsForSerpModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-search',
    pathApi: '/v1/get-newbuildings-for-serp/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetNewbuildingsForSerpOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetNewbuildingsForSerpRequest;
}

export async function fetchGetNewbuildingsForSerp<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingsForSerpOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingsForSerpResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingsForSerpModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingsForSerpResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsForSerpResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingsForSerpResponse>;
}
